import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'icon-speedometer',
    class: 'admin'
  },
  {
    name: 'Dashboard',
    url: '/myDashboard',
    icon: 'icon-speedometer',
    class: 'staff'
  },
  {
    name: 'Expenses',
    url: '/expenses',
    icon: 'fa fa-money',
    class: 'admin'
  },
  {
    name: 'Expenses',
    url: '/myExpenses',
    icon: 'fa fa-money',
    class: 'staff'
  },
  {
    name: 'Visit Report',
    url: '/visit_report',
    icon: 'fa fa-location-arrow',
    class: 'admin'
  },
  {
    name: 'Leave Request',
    url: '/leave_request',
    icon: 'fa fa-user',
    class: 'admin'
  },
  {
    name: 'Salary',
    url: '/salary',
    icon: 'fa fa-money',
    class: 'admin'
  },
  {
    name: 'Experience Letter',
    url: '/experience_letter',
    icon: 'fa fa-money',
    class: 'admin'
  },
  {
    name: 'Salary',
    url: '/mySalary',
    icon: 'fa fa-money',
    class: 'staff'
  },
  {
    name: 'Attendance',
    url: '/attendance',
    icon: 'fa fa-calendar',
    class: 'admin',
    children: [
      {
        name: 'Daily',
        url: '/attendance/dayAttendance',
        icon: 'fa fa-calendar-o'
      },
      {
        name: 'User`s',
        url: '/attendance/userMonthlyAttendance',
        icon: 'fa fa-user'
      },
      {
        name: 'Monthly',
        url: '/attendance/monthlyAttendance',
        icon: 'fa fa-user'
      },
      // {
      //   name: 'Update Inquiry',
      //   url: '/views/inquiry/updateInquiry',
      //   icon: 'fa fa-list'
      // }
    ]
  },
  {
    name: 'Setting',
    url: '/setting',
    icon: 'fa fa-gears',
    class: 'admin',
    children: [
      {
        name: 'User',
        url: '/setting/user',
        icon: 'fa fa-user'
      },
      {
        name: 'Organization',
        url: '/setting/organization',
        icon: 'fa fa-bullhorn'
      },
      {
        name: 'Projects',
        url: '/setting/projects',
        icon: 'fa fa-bullhorn'
      },
      {
        name: 'Employee',
        url: '/setting/employee',
        icon: 'fa fa-id-card'
      },
      {
        name: 'Working Days',
        url: '/setting/working_days',
        icon: 'fa fa-bullhorn'
      },
      {
        name: 'Upload Salary',
        url: '/setting/uploadSalary',
        icon: 'fa fa-bullhorn'
      },
      {
        name: 'Upload Expereince Letter',
        url: '/setting/uploadExpereienceLetter',
        icon: 'fa fa-cloud-upload'
      },
    ]
  },
  {
    name: 'Profile',
    url: '/profile',
    icon: 'fa fa-id-card',
    class: 'staff'
  },
  {
    name: 'Logout',
    url:'/logout',
    icon: 'fa fa-power-off',
    class: 'staff'
  },
  {
    name: 'Logout',
    url:'/logout',
    icon: 'fa fa-power-off',
    class: 'admin'
  },
];
